import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import {
  fetchDeleteAbsensi,
  fetchEditAbsensi,
  fetchListAbsensiHarian,
} from "state/absensiActions";
import { BASEURL } from "api/axiosInstance";
import { Delete, Edit, FilterList } from "@mui/icons-material";
import EditAbsensiModal from "components/Modals/EditAbsensiModal";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import CustomFilterModal from "./CustomFilterModal";
import SortableHeader from "components/SortableHeader";
import LokasiCell from "components/Modals/LokasiCell";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import PinModal from "components/Modals/PinModal";
import { fetchCurrentPIN } from "state/userActions";
moment.locale("id");

const RekapAbsensiHarian = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openModalAbsensi, setOpenModalAbsensi] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [openPinDialog, setOpenPinDialog] = useState(false);
  const [pinAction, setPinAction] = useState("");
  const [pendingEditData, setPendingEditData] = useState(null);
  const { status, message } = useSelector((state) => state.global);
  const { list_absensi_harian } = useSelector((state) => state.absensi);
  const { currentPin } = useSelector((state) => state.user);
  const [filteredData, setFilteredData] = React.useState([]);
  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [openCustomFilter, setOpenCustomFilter] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  console.log("list_absensi_harian", list_absensi_harian);

  const columnSort = [
    { value: "id_karyawan", label: "ID Karyawan" },
    { value: "nama_karyawan", label: "Nama Karyawan" },
    { value: "tanggal", label: "Tanggal" },
    { value: "telat_menit", label: "Telat Menit" },
  ];

  useEffect(() => {
    dispatch(fetchListAbsensiHarian());
  }, []);

  useEffect(() => {
    if (list_absensi_harian) {
      const filtered = applyCustomFilters(list_absensi_harian, appliedFilters);
      setFilteredData(filtered);
    }
  }, [list_absensi_harian, appliedFilters]);
  const handleApplyCustomFilter = (filters) => {
    setAppliedFilters(filters);
  };

  const applyCustomFilters = (data, filterConfig) => {
    if (!filterConfig || Object.keys(filterConfig).length === 0) return data;

    let result = [...data];

    if (filterConfig.search && filterConfig.search.trim() !== "") {
      const searchValue = filterConfig.search.toLowerCase();
      result = result.filter((row) => {
        const idMatch = String(row.id_karyawan || "")
          .toLowerCase()
          .includes(searchValue);
        const namaMatch = String(row.nama_karyawan || "")
          .toLowerCase()
          .includes(searchValue);
        return idMatch || namaMatch;
      });
    }

    if (filterConfig.dateRange) {
      const { tanggalAwal, tanggalAkhir } = filterConfig.dateRange;

      if (tanggalAwal || tanggalAkhir) {
        const startBoundary = tanggalAwal
          ? moment(tanggalAwal).startOf("day")
          : null;

        const endBoundary = tanggalAkhir
          ? moment(tanggalAkhir).endOf("day")
          : null;

        result = result.filter((row) => {
          if (!row.tanggal) return false;

          const rowDate = moment(row.tanggal, "DD/MM/YYYY");

          if (!rowDate.isValid()) {
            console.warn(`Invalid date format found for row: ${row.tanggal}`);
            return false;
          }
          const isAfterStart = startBoundary
            ? rowDate.isSameOrAfter(startBoundary)
            : true;

          const isBeforeEnd = endBoundary
            ? rowDate.isSameOrBefore(endBoundary)
            : true;

          return isAfterStart && isBeforeEnd;
        });
      }
    }

    if (filterConfig.filter) {
      if (filterConfig.filter.cabang && filterConfig.filter.cabang.length > 0) {
        result = result.filter((row) => {
          return filterConfig.filter.cabang.includes(row.cabang);
        });
      }

      if (
        filterConfig.filter.nama_jabatan &&
        filterConfig.filter.nama_jabatan.length > 0
      ) {
        result = result.filter((row) => {
          return filterConfig.filter.nama_jabatan.includes(row.nama_jabatan);
        });
      }
    }

    if (filterConfig.sort && filterConfig.sort.length > 0) {
      result.sort((a, b) => {
        for (let sortRule of filterConfig.sort) {
          let { column, order } = sortRule;
          let aValue = a[column];
          let bValue = b[column];

          if (aValue == null) return 1;
          if (bValue == null) return -1;

          if (typeof aValue === "string") aValue = aValue.toLowerCase();
          if (typeof bValue === "string") bValue = bValue.toLowerCase();

          if (aValue < bValue) return order === "asc" ? -1 : 1;
          if (aValue > bValue) return order === "asc" ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  };

  const handleClearCustomFilter = () => {
    setAppliedFilters({});
    setFilteredData([]);
  };

  const getActiveFilterCount = useCallback(() => {
    let count = 0;

    if (appliedFilters.search && appliedFilters.search.trim() !== "") {
      count++;
    }

    if (appliedFilters.dateRange) {
      if (
        appliedFilters.dateRange.tanggalAwal ||
        appliedFilters.dateRange.tanggalAkhir
      ) {
        count++;
      }
    }

    if (appliedFilters.filter) {
      if (appliedFilters.filter.cabang?.length > 0) count++;
      if (appliedFilters.filter.nama_jabatan?.length > 0) count++;
    }
    if (
      Array.isArray(appliedFilters.sort) &&
      appliedFilters.sort.some(
        (item) => item.column && item.column.trim() !== "",
      )
    ) {
      count++;
    }

    return count;
  }, [appliedFilters]);

  const handleSelectedData = useCallback(
    (id) => {
      let currentSelectedData = list_absensi_harian.find(
        (item) => item.sesi_id === id,
      );
      setSelectedData(currentSelectedData);
    },
    [list_absensi_harian],
  );

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListAbsensiHarian());
    setSelectedData(null);
  };

  const handleSubmitEditAbsensi = (value) => {
    const reqData = {
      id: selectedData.sesi_id,
      shift_absen: value.shift_absen,
      telat_menit: value.telat_menit,
      mode_absen: value.mode_absen,
      waktu_masuk: value.waktu_masuk,
      waktu_kedua: value.waktu_kedua,
      waktu_keluar: value.waktu_keluar,
    };

    // Menyimpan data absensi yang diedit di state pendingEditData (disubmit setelah validasi PIN)
    setPendingEditData(reqData);
    setOpenModalAbsensi(false);
    dispatch(fetchCurrentPIN());
    setPinAction("edit");
    setOpenPinDialog(true);
  };

  const handleDeleteAbsensi = (sesi_id) => {
    dispatch(fetchDeleteAbsensi(sesi_id));
    setOpenModalDelete(false);
    setSelectedData(null);
  };

  const columnsAbsensi = useMemo(
    () => [
      {
        name: "sesi_id",
        label: "Sesi ID",
        options: {
          display: false,
        },
      },
      {
        name: "status",
        label: "Status",
        options: {
          display: false,
        },
      },
      {
        name: "id_karyawan",
        label: "ID Karyawan",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "nama_karyawan",
        label: "Nama Karyawan",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "cabang",
        label: "Nama Cabang",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "tanggal",
        label: "Tanggal",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => {
            // Tampilkan tanggal yang sudah diformat di tabel
            return value === "-" || !value ? "-" : value;
          },
        },
      },
      {
        name: "shift_absen",
        label: "Shift Absen",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "waktu_masuk",
        label: "Waktu Masuk",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const shift_absen = tableMeta.rowData[6];
            let cutoffTime;

            if (!value) {
              return <span style={{ color: "gray" }}>-</span>;
            }

            const actualTime = moment(value, "HH:mm:ss");
            if (!actualTime.isValid())
              return <span style={{ color: "black" }}>{value}</span>;

            let cutoffHour = "08:00:00";
            switch (shift_absen) {
              case "Shift 1 Pagi":
                cutoffHour = "07:00:00";
                break;
              case "Shift 2 Siang":
                cutoffHour = "14:00:00";
                break;
              case "Shift Middle":
                cutoffHour = "11:00:00";
                break;
              case "Shift 4":
                cutoffHour = "08:00:00";
                break;
            }

            cutoffTime = moment(
              `${actualTime.format("YYYY-MM-DD")} ${cutoffHour}`,
              "YYYY-MM-DD HH:mm:ss",
            );

            const diffInMinutes = actualTime.diff(cutoffTime, "minutes", true);
            const isLate = diffInMinutes > 1;

            const style = isLate
              ? { color: "red", fontWeight: "bold" }
              : { color: "black" };

            return <span style={style}>{value}</span>;
          },
        },
      },
      {
        name: "waktu_kedua",
        label: "Waktu Kedua",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const waktuMasuk = tableMeta.rowData[tableMeta.columnIndex - 1];
            const shift_absen = tableMeta.rowData[6];

            if (
              !value ||
              value === "-" ||
              value === waktuMasuk ||
              shift_absen !== "Shift 4"
            ) {
              return <span style={{ color: "gray" }}>-</span>;
            }

            const actualTime = moment(value, "HH:mm:ss");
            if (!actualTime.isValid()) {
              return <span style={{ color: "gray" }}>{value}</span>;
            }

            const cutoffTime = moment(
              `${actualTime.format("YYYY-MM-DD")} 15:00:00`,
              "YYYY-MM-DD HH:mm:ss",
            );

            const diffInMinutes = actualTime.diff(cutoffTime, "minutes", true);
            const isLate = diffInMinutes > 1;

            const style = isLate
              ? { color: "red", fontWeight: "bold" }
              : { color: "black" };

            return <span style={style}>{value}</span>;
          },
        },
      },
      {
        name: "waktu_keluar",
        label: "Waktu Keluar",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const status = tableMeta.rowData[2];
            if (!value || value === "-" || status === "Absen Pagi") {
              return "-";
            }

            return value;
          },
        },
      },
      {
        name: "telat_menit",
        label: "Telat Menit",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => {
            const isLate = value > 0;
            const style = isLate
              ? { color: "red", fontWeight: "bold" }
              : { color: "black" };
            return <span style={style}>{Number(value).toFixed(2)}</span>;
          },
        },
      },
      {
        name: "lokasi",
        label: "Lokasi Absen",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => {
            return <LokasiCell text={value} />;
          },
        },
      },
      {
        name: "jenis",
        label: "Jenis Absen",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
            />
          ),
        },
      },
      {
        name: "foto",
        label: "Foto Absen",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
            />
          ),
          customBodyRender: (value) => {
            if (!value) return "-";
            // Pisahkan berdasarkan delimiter " | "
            const items = value.split(" | ");
            return (
              <div>
                {items.map((item, index) => (
                  <div key={index}>
                    <a
                      href={`${BASEURL}/photos/${item}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1976d2", textDecoration: "underline" }}
                    >
                      Foto{index + 1}
                    </a>
                  </div>
                ))}
              </div>
            );
          },
        },
      },
      {
        name: "aksi",
        label: "Aksi",
        options: {
          filter: false,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0];
            if (tableMeta.rowData[6] !== null) {
              return (
                <>
                  <IconButton
                    color="info"
                    onClick={() => {
                      handleSelectedData(id);
                      setOpenModalAbsensi(true);
                    }}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => {
                      handleSelectedData(id);
                      setOpenModalDelete(true);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </>
              );
            }
          },
        },
      },
    ],
    [handleSelectedData],
  );

  const options = useMemo(
    () => ({
      selectableRows: "none",
      filterType: "dropdown",
      filter: false,
      fixedHeader: false,
      fixedSelectColumn: false,
      search: true,
      viewColumns: false,
      responsive: "standard",
      customToolbar: () => {
        const activeCount = getActiveFilterCount();
        return (
          <Button
            startIcon={<FilterList />}
            onClick={() => setOpenCustomFilter(true)}
            variant={activeCount > 0 ? "contained" : "outlined"}
            size="small"
            color={activeCount > 0 ? "primary" : "inherit"}
            sx={{
              mr: 1,
              ...(activeCount === 0 && {
                color: "text.secondary",
                borderColor: "text.secondary",
              }),
            }}
          >
            Filter {activeCount > 0 && `(${activeCount})`}
          </Button>
        );
      },
      rowsPerPageOptions: [
        30,
        60,
        filteredData.length > 0 || Object.keys(appliedFilters).length > 0
          ? filteredData.length
          : list_absensi_harian
            ? list_absensi_harian.length
            : 0,
      ],
      rowsPerPage: rowsPerPage,
      onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
    }),
    [
      filteredData.length,
      list_absensi_harian,
      appliedFilters,
      rowsPerPage,
      getActiveFilterCount,
    ],
  );

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Rekap Absensi Harian"
        subtitle="Daftar absensi harian karyawan."
      />
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={
            filteredData.length > 0 || Object.keys(appliedFilters).length > 0
              ? filteredData
              : list_absensi_harian
          }
          columns={columnsAbsensi}
          options={options}
        />
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_absensi_harian}
          sortableColumns={columnSort}
        />
        <EditAbsensiModal
          open={openModalAbsensi}
          dataEdit={selectedData}
          onClose={() => setOpenModalAbsensi(false)}
          onSubmit={(value) => handleSubmitEditAbsensi(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={"Hapus"}
          subtitleType={"Menghapus Absensi"}
          dataWillProses={selectedData?.nama_karyawan}
          open={openModalDelete}
          onClose={() => setOpenModalDelete(false)}
          onSubmit={() => {
            setOpenModalDelete(false);
            dispatch(fetchCurrentPIN());
            setPinAction("delete");
            setOpenPinDialog(true);
          }}
        />
        <PinModal
          open={openPinDialog}
          onClose={() => {
            setOpenPinDialog(false);
            setSelectedData(null);
            setPinAction("");
            setPendingEditData(null);
          }}
          title="Verifikasi PIN"
          subtitle={
            pinAction === "delete"
              ? "Masukkan 6 digit PIN untuk menghapus data ini."
              : "Masukkan 6 digit PIN untuk menyimpan perubahan data."
          }
          correctPin={currentPin}
          onSuccess={() => {
            if (pinAction === "delete") {
              handleDeleteAbsensi(selectedData.sesi_id);
            } else if (pinAction === "edit") {
              dispatch(fetchEditAbsensi(pendingEditData));
              setOpenPinDialog(false);
              setPinAction("");
              setPendingEditData(null);
              setSelectedData(null);
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default RekapAbsensiHarian;
